import React, { useEffect } from 'react';
import {
  SOURCE_AND_DEVICE_TYPE,
} from '../../constants';
import {
  getSourceAndDeviceType,
  isNotLoginOrRegisterPath,
} from '../../helpers';
import Header from './Header';
import UseSyncSoComAffiliateWithBag from '../../hooks/useSyncSoComAffiliateWithBag/useSyncSoComAffiliateWithBag';
import useDeviceTypeListener from '../../hooks/useDeviceTypeListener/useDeviceTypeListener';

function HeaderVM() {
  const deviceType = useDeviceTypeListener();
  const { pathname } = window.location;
  const memberWalletHeader = window?.FLAGS?.MemberWallet || false;
  const memberWalletEnhancement =
    window?.FLAGS?.MemberWalletEnhancement || false;
  const addToBagFlyoutEnabled = window?.FLAGS?.AddToBagFlyout || false;

  useEffect(() => {
    const isValidPathname = isNotLoginOrRegisterPath(pathname);
    if (isValidPathname) {
      const sourceAndDeviceType = getSourceAndDeviceType(
        SOURCE_AND_DEVICE_TYPE,
        deviceType,
        window.location.pathname,
      );

      window.sessionStorage.setItem(
        'OriginRoutePathnameToCreate',
        sourceAndDeviceType,
      );
    }
  }, [deviceType, pathname]);

  UseSyncSoComAffiliateWithBag();

  return (
    <Header
      memberWalletHeader={memberWalletHeader}
      memberWalletEnhancement={memberWalletEnhancement}
      addToBagFlyoutEnabled={addToBagFlyoutEnabled}
    />
  );
}

export default HeaderVM;
